module.exports = __webpack_public_path__ + "static/media/victoria.821746aa.png";